module.exports = __webpack_public_path__ + "assets/4b0ce6f65010dbddb5c3a546b3dd7c1f.png";